module.exports = __webpack_public_path__ + "img/calendar_icon.4563a436.png";